import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { FiltrosGuias, Guia } from "../models/guias.model";

@Injectable({
  providedIn: "root",
})
export class GuiasService {
  private guias$ = new BehaviorSubject<Guia[]>(null);
  constructor(private http: HttpClient) {}

  public getAll(id?: any) {
    this.http
      .get<Guia[]>(`${environment.rotaGuias}/carteiraGuiasNaoAtendidas/${id}`)
      .pipe(take(1))
      .subscribe((guias) => this.guias$.next(guias));
  }

  public escutarMudancasGuia(): Observable<Guia[]> {
    return this.guias$.asObservable();
  }

  public atualizarGuias(guias: Guia[]) {
    return this.guias$.next(guias);
  }

  private updateGuiaInState(updatedGuia: Guia) {
    this.guias$.pipe(take(1)).subscribe((guias) => {
      // Substitui a guia atualizada na lista do BehaviorSubject
      const updatedGuias = guias.map((guia) =>
        guia._id === updatedGuia._id ? updatedGuia : guia
      );
      // Atualiza o BehaviorSubject com a nova lista
      this.guias$.next(updatedGuias);
    });
  }
  public getAllConsultor(id?: any) {
    this.http
      .get<Guia[]>(
        `${environment.rotaGuias}/carteiraGuiasConsultorNaoAtendidas/${id}`
      )
      .pipe(take(1))
      .subscribe((guias) => this.guias$.next(guias));
  }

  public getAllEmpresarial(id?: any) {
    this.http
      .post<Guia[]>(`${environment.rotaGuias}/carteiraGuias/${id}`, {})
      .pipe(take(1))
      .subscribe((guias) => this.guias$.next(guias));
  }

  public getAllAdmin() {
    this.http
      .get<Guia[]>(`${environment.rotaGuias}/nao-atendidas`)
      .pipe(take(1))
      .subscribe((guias) => this.guias$.next(guias));
  }

  public edit(updatedGuia: Guia) {
    return this.http
      .patch(`${environment.rotaGuias}/${updatedGuia._id}`, updatedGuia)
      .pipe(
        map(() => {
          // Atualiza a lista localmente após sucesso na atualização do servidor
          this.updateGuiaInState(updatedGuia);
        }),
        catchError((error) => throwError("Erro ao atualizar guia: " + error))
      );
  }

  public create(guia: Guia): Observable<any> {
    return this.http.post(environment.rotaGuias, guia);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete(environment.rotaGuias + "/" + id);
  }
}
